<template>
  <div class="newHead">
    <div class="left">
      <van-icon v-if="isBack" name="arrow-left" @click="$router.back()"  />
    </div>
    <div class="title">{{title}}</div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  /**
   *不改动原来组件, 第三版头部组件
   */
  name: "newHead",
  props:{
      title:{},
      isBack:{
        type:Boolean,
        default() {
          return true
        }
      }
  }
};
</script>

<style lang="scss" scoped>
.newHead {
  z-index: 599;
  height: 44px;
  color: white;
  background: linear-gradient(159deg, #0286ff 0%, #074fc7 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 15px;
  font-size: 18px;
}
</style>